import { useFormContext } from 'react-hook-form';
import { CancelButton, SaveButton } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';

import { PresetsCreateFormValues } from './PresetsCreateForm/PresetsCreateForm';

export const PresetsCreateActions: React.FC = () => {
  const { watch } = useFormContext<PresetsCreateFormValues>();
  const [paymentItems, payoutItems] = watch(['paymentItems', 'payoutItems']);
  const hasNoPresets = !paymentItems?.length && !payoutItems?.length;

  return (
    <CardActionsButtons
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButton disabled={hasNoPresets} key="save-button" label="Создать" />,
      ]}
      sx={{ padding: 0 }}
    />
  );
};
